export default __webpack_public_path__ + "static/media/list.3ce9a40a.svg";